import { AuthJwtObject } from './Auth.types';

const isAuthJwtObject = (arg: any): arg is AuthJwtObject => {
  return (
    !!arg && typeof arg === 'object' && !Array.isArray(arg) && 'token' in arg && 'expires' in arg
  );
};

export { isAuthJwtObject };
